module.exports = __webpack_public_path__ + "static/media/documentsContent.0cecb6e7.png";